<div class="modal-header">
  <h4 class="modal-title" id="modal-title">Upload / Export</h4>
</div>
<div class="modal-body" style=" max-height: Calc(90vh - 50px);" >

  @if(IsCalculating())
  {
    <p>
      Generiere Datendatei @if(this.FileGenerating()) { <Spinner [size]="12"></Spinner> } @else { <i style="color: green;" class="fa-solid fa-circle-check"></i> }
      @if(FileGenerated())
      {
      <br />
        Kopiere Datei {{AktuellerEintrag()}} von {{AnzahlEintraege()}}. @if(!StartDownloadFile()){ <Spinner [size]="12"></Spinner> ({{CalculatePercentage() | number: '1.0-0'}} %) } @else{<i style="color: green;" class="fa-solid fa-circle-check"></i>}
      }

      @if(StartDownloadFile())
      {
      <br />
      Download .ZIP: <Spinner [size]="12"></Spinner>
      }
    </p>
  }

  @if(ShowErrorInfo())
  {
    <div class="alert alert-danger" role="alert">
      Beim Export ist ein Fehler aufgetreten! Versuchen sie es Später erneut!
    </div>
  }
  @if(Success())
  {
    <h3 class="alert alert-success" role="alert">Export Abgeschlossen</h3>
  }
  @if(CanClose())
  {
    <div class="btn btn-primary w-100" (click)="modal.dismiss('Cross click')">OK</div>
  }
</div>
